"use client";
import { useProgressRouter } from "@lib/util/navigation";
import { Input } from "@medusajs/ui";
import { useSearchParams } from "next/navigation";
import React, { useEffect, useState } from "react";

const formatCurrency = (value: number | "") => (value === "" ? "" : value.toLocaleString("vi-VN"));

const parseCurrency = (value: string): number | "" => {
  const numberOnly = value.replace(/[^\d]/g, "");
  return numberOnly === "" ? "" : Number(numberOnly);
};

const FilterRange = () => {
  const router = useProgressRouter();
  const searchParams = useSearchParams();

  const [minPrice, setMinPrice] = useState<number | "">("");
  const [maxPrice, setMaxPrice] = useState<number | "">("");

  const [debouncedMin, setDebouncedMin] = useState<number | "">("");
  const [debouncedMax, setDebouncedMax] = useState<number | "">("");

  useEffect(() => {
    const priceRangeParam = searchParams.get("price_range");

    if (priceRangeParam) {
      try {
        const { from, to } = JSON.parse(priceRangeParam);
        setMinPrice(from ?? "");
        setMaxPrice(to ?? "");
        setDebouncedMin(from ?? "");
        setDebouncedMax(to ?? "");
      } catch (err) {
        console.error("Invalid price_range format in URL", err);
      }
    }
  }, [searchParams]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setDebouncedMin(minPrice);
      setDebouncedMax(maxPrice);
    }, 500);
    return () => clearTimeout(timeout);
  }, [minPrice, maxPrice]);

  useEffect(() => {
    const params = new URLSearchParams(searchParams.toString());

    const priceRange: Record<string, number> = {};

    const from = debouncedMin !== "" && debouncedMin != null ? Number(debouncedMin) : null;
    const to = debouncedMax !== "" && debouncedMax != null ? Number(debouncedMax) : null;

    if (from !== null) priceRange.from = from;
    if (to !== null) priceRange.to = to;
    params.delete("page");
    if (Object.keys(priceRange).length > 0) {
      params.set("price_range", JSON.stringify(priceRange));
    } else {
      params.delete("price_range");
    }

    router.replace(`?${decodeURIComponent(params.toString())}`, {
      scroll: false,
    });
  }, [debouncedMin, debouncedMax]);

  const handleMinChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = parseCurrency(e.target.value);
    setMinPrice(value);
  };

  const handleMaxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = parseCurrency(e.target.value);
    setMaxPrice(value);
  };

  return (
    <div className="flex items-center gap-2 py-4">
      <Input
        type="text"
        inputMode="numeric"
        placeholder="Từ"
        value={formatCurrency(minPrice)}
        onChange={handleMinChange}
      />
      <span>-</span>
      <Input
        type="text"
        inputMode="numeric"
        placeholder="Đến"
        value={formatCurrency(maxPrice)}
        onChange={handleMaxChange}
      />
    </div>
  );
};

export default FilterRange;
